import React from 'react';
import { uuidv4 } from '../../../utils/utility';
import { FormattedMessage } from 'react-intl';
import './checkBox.scss';
const Checkbox = ({
  name,
  label = ' ',
  parentInputClassName = '',
  inputClassName = '',
  className = '',
  style = {},
  checked = false,
  theme = 'light',
  tabIndex = 0,
  id = uuidv4(),
  onChange = () => {},
  isLocalization = true,
  ...rest
}) => {
  let checkedClass = '';
  //TODO:should chane type of checked proprty to be boolean
  if (checked) {
    checkedClass = 'checkBoxInputChecked';
  }

  return (
    <div className={`${parentInputClassName} exp input-checkBox-${theme}-mode`}>
      <input
        className="checkBoxLabel cursor-pointer d-none"
        type="checkbox"
        id={id}
        checked={checked}
        name={name}
        onChange={onChange}
        {...rest}
      />
      <label
        className={`checkBoxLabel cursor-pointer d-flex align-items-center  ${inputClassName} ${checkedClass}`}
        style={style}
        htmlFor={id}
        tabIndex={tabIndex ? tabIndex : 0}
      >
        <span
          tabIndex={tabIndex ? tabIndex : 0}
          style={{ outline: 'none' }}
          id={`span${id}`}
          onFocus={() =>
            document.getElementById(`span${id}`).classList.add('inputBoxShadow')
          }
          onBlur={() =>
            document
              .getElementById(`span${id}`)
              .classList.remove('inputBoxShadow')
          }
          className="mx-1 d-inline-block checkBoxSpan text-muted"
          // style={{ boxShadow: "rgb(246, 246, 246) 0px 1px 1px 1px" }}
        />
        {isLocalization ? (
          <FormattedMessage id={label} defaultMessage={label} />
        ) : (
          label
        )}
      </label>
    </div>
  );
};
export default Checkbox;
